import { useContext } from 'react';
import { AppContext } from '@/App';
import Dashboard from '@/pages/Dashboard';
import Welcome from '@/pages/Welcome';

// Component that shows Dashboard or Welcome based on user permissions
function HomeRoute() {
  const { user } = useContext(AppContext);
  
  // Check if user has dashboard access
  const hasDashboardAccess = () => {
    if (!user) return false;
    
    // Admin and Manager always have dashboard access
    if (user.role === 'Admin' || user.role === 'Manager') return true;
    
    // Check if dashboard is hidden for this role
    if (user.permissions?.hideDashboard) return false;
    
    // Check custom page_access for dashboard
    if (user.page_access && typeof user.page_access === 'object') {
      const access = user.page_access['/'];
      if (access === 'view' || access === 'edit' || access === 'full') return true;
      // If user has custom page_access but dashboard is not in it, deny
      if (Object.keys(user.page_access).length > 0) return false;
    }
    
    // Check role-based permissions
    if (user.permissions?.pages) {
      if (user.permissions.pages.includes('*')) return true;
      if (user.permissions.pages.includes('/')) return true;
    }
    
    // Default: no access for DataEntry and Employee
    if (user.role === 'DataEntry' || user.role === 'Employee') return false;
    
    return true;
  };

  if (hasDashboardAccess()) {
    return <Dashboard />;
  }
  
  return <Welcome />;
}

export default HomeRoute;
